import React from "react";

function RightSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="58"
      fill="none"
      viewBox="0 0 59 58"
    >
      <rect
        width="55"
        height="55"
        x="2.405"
        y="1.5"
        fill="#374151"
        rx="27.5"
      ></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M26.905 35l6-6-6-6"
      ></path>
      <rect
        width="55"
        height="55"
        x="2.405"
        y="1.5"
        stroke="#4B5563"
        strokeWidth="3"
        rx="27.5"
      ></rect>
    </svg>
  );
}

export default RightSvg;
